import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { UserProfile } from '@shared/ui/user-profile/user-profile';
import { Menu } from '@vtbhome/juicyfront';
import { useLogout } from '@features/current-user/logout/lib/hooks/use-logout/use-logout';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { useEffect } from 'react';
import { useProfileEditMutation } from '@features/current-user/edit-profile/api/profile-edit-api';
import { useProductsListSharedQuery } from '@entities/product/libs/hooks/use-products-list-shared-query/use-products-list-shared-query';
import { DEFAULT_PRODUCTS_LIST_PARAMETERS } from '@entities/product/config/store-constants';

export const CardCurrentUserProfile = () => {
    const { logout } = useLogout();
    const user = useCurrentUserSelector();
    const [editUser] = useProfileEditMutation();
    const [, , resetAvailableProductsList] = useProductsListSharedQuery(DEFAULT_PRODUCTS_LIST_PARAMETERS);

    useEffect(() => {
        if (user?.id) {
            editUser({
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
            }).then(() => resetAvailableProductsList());
        }
    }, [user?.id]);

    return (
        <Menu list={[{ label: 'Выйти', handler: logout }]}>
            <UserProfile
                avatarUrl={user?.photoUrl || ''}
                text={
                    userName({ firstName: user?.firstName, lastName: user?.lastName, middleName: user?.middleName })
                        .full
                }
            />
        </Menu>
    );
};
